/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GHUBPRODUCTCODE = {
    DiscretionarySavings: 'GAFDSP',
    Endowment: 'GAFEND',
    RetirementIncomeSolutionLivingAnnuity: 'GAFLAI',
    ManagedLivingAnnuity: 'GAFLAM',
    LivingAnnuity: 'GAFLAN',
    PreservationPensionFund: 'GAFPPE',
    PreservationProvidentFund: 'GAFPPR',
    RetirementAnnuityFund: 'GAFRAF',
    SinkingFund: 'GAFSNK',
    TaxFreeSavings: 'GAFTFS'
} as const;
export type GHUBPRODUCTCODE = typeof GHUBPRODUCTCODE[keyof typeof GHUBPRODUCTCODE];


export function GHUBPRODUCTCODEFromJSON(json: any): GHUBPRODUCTCODE {
    return GHUBPRODUCTCODEFromJSONTyped(json, false);
}

export function GHUBPRODUCTCODEFromJSONTyped(json: any, ignoreDiscriminator: boolean): GHUBPRODUCTCODE {
    return json as GHUBPRODUCTCODE;
}

export function GHUBPRODUCTCODEToJSON(value?: GHUBPRODUCTCODE | null): any {
    return value as any;
}

